/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Was der Sammelversand bewirkt hat.
 * @export
 * @interface MailversandErgebnis
 */
export interface MailversandErgebnis {
    /**
     * Mails, die das Backend abgeschickt hat.
     * @type {number}
     * @memberof MailversandErgebnis
     */
    gesendet?: number;
    /**
     * Datensaetze, bei denen das gewaehlte Feld leer war. KEIN Fehler, aber eine Zahl, die dastehen muss: Sonst haelt man 30 verschickte von 50 markierten fuer einen Fehlschlag -- oder schlimmer, merkt gar nicht, dass 20 Leute nichts bekommen haben.
     * @type {number}
     * @memberof MailversandErgebnis
     */
    ohneAdresse?: number;
    /**
     * Mails, die das Backend nicht zustellen konnte.
     * @type {number}
     * @memberof MailversandErgebnis
     */
    fehlgeschlagen?: number;
    /**
     * Ob die Protokolldatei den Eigentuemer erreicht hat. Falsch, wenn kein Protokoll angefordert war ODER der Versand des Protokolls selbst scheiterte -- der Sammelversand gilt deswegen NICHT als gescheitert.
     * @type {boolean}
     * @memberof MailversandErgebnis
     */
    protokollGesendet?: boolean;
    /**
     * Ein Satz fuer den Bildschirm, in ganzen Worten.
     * @type {string}
     * @memberof MailversandErgebnis
     */
    meldung?: string;
}

/**
 * Check if a given object implements the MailversandErgebnis interface.
 */
export function instanceOfMailversandErgebnis(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MailversandErgebnisFromJSON(json: any): MailversandErgebnis {
    return MailversandErgebnisFromJSONTyped(json, false);
}

export function MailversandErgebnisFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailversandErgebnis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gesendet': !exists(json, 'gesendet') ? undefined : json['gesendet'],
        'ohneAdresse': !exists(json, 'ohneAdresse') ? undefined : json['ohneAdresse'],
        'fehlgeschlagen': !exists(json, 'fehlgeschlagen') ? undefined : json['fehlgeschlagen'],
        'protokollGesendet': !exists(json, 'protokollGesendet') ? undefined : json['protokollGesendet'],
        'meldung': !exists(json, 'meldung') ? undefined : json['meldung'],
    };
}

export function MailversandErgebnisToJSON(value?: MailversandErgebnis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gesendet': value.gesendet,
        'ohneAdresse': value.ohneAdresse,
        'fehlgeschlagen': value.fehlgeschlagen,
        'protokollGesendet': value.protokollGesendet,
        'meldung': value.meldung,
    };
}

